export default {
  get_product:{}
}
